module.exports = __webpack_public_path__ + "static/media/ohren.6902cf10.png";